// extracted by mini-css-extract-plugin
export default {"resetButton":"YDTvUf3","containerDisabled":"DV3Lqs1","groupTitle":"Qdkl8xM","withBorder":"AGyQaSq","title":"HyYQbob","createButton":"lnQHV7d","count":"aLA4Xfi","documents":"s17rfht"};